export const C_CARD_CLASSNAME = 'c-card';
export const C_VIDEO_CARD_INLINE_SLIM_CLASSNAME = 'c-video-card-inline-slim';
export const C_VIDEO_CARD_INLINE_CLASSNAME = 'c-video-card-inline';
